import { BRAND_LIST, CountryLanguageSwitcher, DistanceUnit } from 'typings'
import * as Typings from '../typings'

const CzechLocale: Typings.LocaleType = {
  IS_EU: true,
  REGION: Typings.RegionGroupNames.OTHER,
  CODE: 'CZ',
  LANGUAGE_CODE: 'en',

  LONG_NAME: 'Czech Republic',
  SHORT_NAME: 'CZ',

  DISPLAY_NAME: 'Czech Republic (English)',
  DISPLAY_COUNTRY: 'Czech Republic (English)',

  GEO_COORDINATES: {
    INITIAL_LATITUDE: 49.7773397,
    INITIAL_LONGITUDE: 12.835902,
    INITIAL_ZOOM: 5,
    INITIAL_ZOOM_DETAILS_PAGE: 15,
  },

  AREAS: {
    '1': 'Central Bohemian',
    '2': 'Czech Republic',
    '3': 'Hradec Králové',
    '4': 'Karlovy Vary',
    '5': 'Liberec',
    '6': 'Moravian-Silesian',
    '7': 'Olomouc',
    '8': 'Pardubice',
    '9': 'Plzeň',
    '10': 'Prague',
    '11': 'South Bohemian',
    '12': 'South Moravian',
    '13': 'Ústí nad Labem',
    '14': 'Vysočina',
    '15': 'Zlín',
  },

  HOME_PAGE_URL: 'https://www.uniqlo.com/eu-cz/en/',

  MAP_MOBILE_URL: 'https://map.uniqlo.com/eu-cz/en/',

  CONTACT_US_URL: 'https://faq-eu.uniqlo.com/',
  TERMS_OF_USE_URL:
    'https://faq-eu.uniqlo.com/pkb_Home_UQ_EU?l=en&c=category_uq_eu_dk_se%3ARenew_UQEU_C7_3',
  PRIVACY_POLICY_URL:
    'https://faq-eu.uniqlo.com/pkb_Home_UQ_EU?l=dk&c=category_uq_eu_dk_se%3ARenew_UQEU_C7_2',
  POSTCODE_FORMAT: /^[0-9]{3} [0-9]{2}$/,

  CLIENT_ID: {
    [BRAND_LIST.UQ]: '',
  },

  DISTANCE_UNIT: DistanceUnit.KM,

  SHOW_COUNTRY_LANGUAGE_MODAL: {
    [BRAND_LIST.UQ]: CountryLanguageSwitcher.HEADER_SWITCHER_MODAL,
    [BRAND_LIST.GU]: CountryLanguageSwitcher.ALL_DISABLED,
    [BRAND_LIST.PL]: CountryLanguageSwitcher.ALL_DISABLED,
  },

  ONE_TRUST_FOOTER: {
    [BRAND_LIST.UQ]: true,
  },
}

export default CzechLocale
